import React, { useEffect, useState, useMemo } from "react";
import callApi from "services/api";
import {
  faArrowLeft,
  faEdit,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatDate } from "utils/DateFormatter";
import { loadingState } from "global/LoaderState";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import { AlertState } from "global/AlertState";
// import AddDelinquency from "./AddDelinquency_org";
import debounce from "lodash.debounce";
import { UserState } from "global/UserState";
import { useLocation } from "react-router-dom";
import { getMasterdata } from "../delinquency/apis";
const AdminUnitDelinquency = () => {
  const [showModal, setShowModal] = useState(false);

  const [user] = useRecoilState(UserState);
  const loader = useSetRecoilState(loadingState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [empList, setEmpList] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const limit = 10;
  const location = useLocation();
  const item = location.state?.item;
  const unitName = location.state?.UnitName;

  const getEmployeeList = async (search, page = 1) => {
    try {
      loader(true);
      setLoading(true);
      setError(null);

      // const params = new URLSearchParams({
      //   search: search || "",
      //   search_field: "name",
      //   page: page.toString(),
      //   limit: limit.toString(),
      //   ...(item && { employeeId: item }), // Only add employeeId if item exists
      // });

      const params = new URLSearchParams({
        search: search || "",
        search_field: "name",
        page: page.toString(),
        limit: limit.toString(),
      });

      const response = await callApi(
        `filtermaster/employee/details/${item}?${params}`,
        "GET",
        null,
        true,
        true,
        (msg) => setError(msg),
        (path) => console.log("navigate to", path),
      );
      if (response.success) {
        const body = response?.body || {};
        setEmpList(body?.data);
        setCurrentPage(body.current_page || 1);
        setTotalPages(body.total_pages || 1);
        setTotalRecords(body.total_count || 0);
      }
    } catch (err) {
      setError(err.message || "Failed to load employees");
    } finally {
      loader(false);
      setLoading(false);
    }
  };

  const debouncedGetEmployeeList = useMemo(
    () =>
      debounce((query, page) => {
        getEmployeeList(query, page);
      }, 300),
    [],
  );

  const handleViewDeliquency = (data) => {
    navigate("/admin-deliquency", {
      state: { data, item, unitName },
    });
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    setCurrentPage(1);
    debouncedGetEmployeeList(value, 1);
  };

  const renderRows = () => {
    if (!empList || empList?.length === 0) {
      return (
        <tr>
          <td colSpan={7} className="p-3 text-start">
            No Data
          </td>
        </tr>
      );
    }
    return empList?.map((item) => (
      <tr key={item.id}>
        <td className="text-center">{item.empCode}</td>
        <td className="text-center">{item.name}</td>
        <td className="text-center">
          {new Date(item.dob).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </td>
        <td className="text-center">{item.rankName}</td>
        <td className="text-center">{item.beltNumber}</td>
        <td className="text-center">{item.postingName}</td>
        <td className="text-center">
          <button
            type="button"
            onClick={() => handleViewDeliquency(item)}
            className="btn btn-sm btn-link me-1"
            style={{ textDecoration: "none" }}
          >
            <FontAwesomeIcon icon={faEdit} className="me-1" />
            View Delinquencies
          </button>
        </td>
      </tr>
    ));
  };
  useEffect(() => {
    getEmployeeList();
  }, []);

  return (
    <>
      <div className="container">
        <div className="ms-3 me-3 mt-3 d-flex justify-content-between bg-dark rounded ">
          <div className="d-flex align-items-center">
            <button
              className="btn btn-link text-white"
              onClick={() => navigate(-1)}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
            <h5 className="card-title text-white m-0">Employees</h5>
          </div>
          <h6 className="card-title p-3 mt-1 text-white text-sm">
            Department : {user.unit || ""}
            {user.subUnit ? ` | ${user.subUnit}` : `${unitName}`}
          </h6>
        </div>
        <div className="card-body ms-3">
          <>
            {/* <div className="row mb-3 mt-4 ps-4">
            <form className="form-inline d-flex ">
              <div className="col-md-4 ">
                <div
                  className="position-relative w-100 "
                  style={{ maxWidth: "400px" }}
                >
                 
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                    style={{ pointerEvents: "none" }} 
                  />

                
                  <input
                    type="text"
                    name="questionName"
                    onChange={handleSearchChange}
                    placeholder="Type a employee name for search"
                    className="form-control ps-5 py-2"
                    style={{
                      borderRadius: "0.5rem",
                      boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
              </div>
            </form>
          </div> */}
            <div className="mt-4 table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th className="text-center">Unique Id</th>
                    <th className="text-center">Name</th>
                    <th className="text-center">Date Of Birth</th>
                    <th className="text-center">Rank</th>
                    <th className="text-center">Belt Number</th>
                    <th className="text-center">Posting</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>{renderRows()}</tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div>
                Page {currentPage} of {totalPages} | Total Records:{" "}
                {totalRecords}
              </div>

              <div>
                <button
                  disabled={currentPage === 1}
                  onClick={() => getEmployeeList(search, currentPage - 1)}
                  className="btn btn-sm btn-outline-primary me-2"
                >
                  Previous
                </button>

                <button
                  disabled={currentPage === totalPages}
                  onClick={() => getEmployeeList(search, currentPage + 1)}
                  className="btn btn-sm btn-outline-primary"
                >
                  Next
                </button>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default AdminUnitDelinquency;
